//------------
// グラフ種別
// @warning 既存IDはFirestoreに保存しているため、絶対に変更禁止
//------------
export const GRAPH_KIND = {
  NONE: -1,
  LINE: 1,
  LINE_VERTICAL: 15,
  BAR: 2,
  AREA: 3,
  COMPOSE: 4,
  CUMULATIVE: 5,
  TIMELINE: 6,
  RADAR: 7,
  PIE: 8,
  SCATTER: 9,
  HISTOGRAM: 10,
  TREEGRAPH: 11,
  TREEMAP: 12,
  HEATMAP: 13,
  TABLE: 14,
} as const;

// 次に追加する場合の値
// NEXT_AVAILABLE_ID: 16

export type GraphKind = (typeof GRAPH_KIND)[keyof typeof GRAPH_KIND];

//------------
// グラフ情報
//------------
export type GraphKindInfo = {
  type: GraphKind;
  name: string;
  iconPath: string;
};

export const GraphKindInfo: GraphKindInfo[] = [
  {
    type: GRAPH_KIND.LINE,
    name: "線グラフ",
    iconPath: "/icon/graph/line.png",
  },
  // {
  //   type: GRAPH_KIND.LINE_VERTICAL,
  //   name: "線グラフ（縦）",
  //   iconPath: "/icon/graph/line.png",
  // },
  {
    type: GRAPH_KIND.BAR,
    name: "棒グラフ",
    iconPath: "/icon/graph/bar.png",
  },
  {
    type: GRAPH_KIND.AREA,
    name: "層グラフ",
    iconPath: "/icon/graph/area.png",
  },
  {
    type: GRAPH_KIND.COMPOSE,
    name: "複合グラフ",
    iconPath: "/icon/graph/compose.png",
  },
  {
    type: GRAPH_KIND.CUMULATIVE,
    name: "累積グラフ",
    iconPath: "/icon/graph/cumulative.png",
  },
  {
    type: GRAPH_KIND.TIMELINE,
    name: "タイムライン",
    iconPath: "/icon/graph/timeline.png",
  },
  {
    type: GRAPH_KIND.RADAR,
    name: "レーダーチャート",
    iconPath: "/icon/graph/redar.png",
  },
  {
    type: GRAPH_KIND.PIE,
    name: "円グラフ",
    iconPath: "/icon/graph/pie.png",
  },
  {
    type: GRAPH_KIND.SCATTER,
    name: "散布図",
    iconPath: "/icon/graph/scatter.png",
  },
  {
    type: GRAPH_KIND.HISTOGRAM,
    name: "ヒストグラム",
    iconPath: "/icon/graph/histogram.png",
  },
  {
    type: GRAPH_KIND.TREEGRAPH,
    name: "ツリーグラフ",
    iconPath: "/icon/graph/tree_graph.png",
  },
  {
    type: GRAPH_KIND.TREEMAP,
    name: "ツリーマップ",
    iconPath: "/icon/graph/tree_map.png",
  },
  {
    type: GRAPH_KIND.HEATMAP,
    name: "ヒートマップ",
    iconPath: "/icon/graph/heatmap.png",
  },
  {
    type: GRAPH_KIND.TABLE,
    name: "表",
    iconPath: "/icon/graph/table.png",
  },
];
